import React from 'react';
import styled from 'styled-components';
import { space, layout, flexbox, border } from 'styled-system';
import { color, typography, variant } from 'styled-system';
import theme, { colors } from '@styles/theme';

export const Button = styled('button')(
  {
    background: 'none',
    ...theme.buttons.base
  },
  variant({ scale: 'buttons' }),
  space,
  layout,
  flexbox,
  border,
  color,
  typography
);

Button.displayName = 'Button';

Button.BAB = props => <Button type="button" {...props} variant="BAB" />;
Button.FCQ = props => <Button type="button" {...props} variant="FCQ" />;
Button.buttonGroupActive = props => (
  <Button type="button" {...props} variant="buttonGroupActive" />
);
Button.buttonGroupInactive = props => (
  <Button type="button" {...props} variant="buttonGroupInactive" />
);
Button.form = ({ onClick, ...props }) => (
  <Button
    type="button"
    variant="form"
    bg={props.disabled ? 'grayscale.gray' : 'primary'}
    onClick={props.disabled ? () => {} : onClick}
    {...props}
  />
);
Button.formNoBg = ({ onClick, inverted, ...props }) => (
  <Button
    type="button"
    variant="formNoBg"
    bg={'transparent'}
    onClick={props.disabled ? () => {} : onClick}
    border={
      props.disabled
        ? `1px solid ${colors.grayscale.gray}`
        : inverted
        ? `1px solid ${colors.lightestPrimary}`
        : `1px solid ${colors.primary}`
    }
    color={props.disabled ? 'grayscale.gray' : inverted ? 'lightestPrimary' : 'primary'}
    {...props}
  />
);
Button.inverted = ({ onClick, ...props }) => (
  <Button
    type="button"
    variant="inverted"
    {...props}
    bg={props.disabled ? 'grayscale.gray' : 'lightestPrimary'}
    onClick={props.disabled ? () => {} : onClick}
  />
);
Button.select = props => <Button type="button" variant="select" {...props} />;
Button.primary = props => <Button type="button" variant="primary" {...props} />;
Button.text = props => <Button type="button" {...props} variant="text" />;
Button.textUppercase = props => (
  <Button type="button" {...props} variant="textUppercase" />
);

// Website
Button.cta = props => <Button type="button" {...props} variant="cta" />;

Button.withHover = props => (
  <Button
    type="button"
    width="100%"
    textAlign="inherit"
    css={`
      cursor: 'pointer',
      '&:hover': {
        backgroundcolor: ${colors.focused};
      }
    `}
    {...props}
  />
);
export default Button;
